import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=2ea15dc0&scoped=true&"
import script from "./Book.vue?vue&type=script&lang=ts&"
export * from "./Book.vue?vue&type=script&lang=ts&"
import style0 from "./Book.vue?vue&type=style&index=0&id=2ea15dc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea15dc0",
  null
  
)

export default component.exports